import { CAPTURES_TYPES } from "./capturesTypes";

const {
  SET_CAPTURES,
  SET_ROUTE_CYCLES,
  SET_SELECTED_ROUTE_CYCLE,
  NEW_CAPTURE,
  SET_NEW_CAPTURE,
  EDIT_CAPTURE,
  SET_EDITED_CAPTURE,
  DELETE_CAPTURE,
  CLEAR_CAPTURES,
  SET_CANCEL_MOTIVES,
  LOAD_CAPTURES,
  HANDLE_CAPTURES_INPUTS,
} = CAPTURES_TYPES;

const initialState = {
  captures: [],
  routeCycles: [],
  routeCycleSelected: null,
  motives: [],
  station: null,
  //edit
  isAddMode: false,
  isDeleteMode: false,
  editCapture: null,

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

export const capturesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_CAPTURES_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case SET_CANCEL_MOTIVES:
      return {
        ...state,
        motives: payload
      };
    case LOAD_CAPTURES:
      return {
        ...state,
        isLoadingPage: true
      };

    case SET_CAPTURES:
      return {
        ...state,
        captures: payload.captures
      };

    case SET_ROUTE_CYCLES:
      return {
        ...state,
        routeCycles: payload.routeCycles
      };

    case SET_SELECTED_ROUTE_CYCLE:
      return {
        ...state,
        routeCycleSelected: payload
      };

    case EDIT_CAPTURE:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: false,
        editCapture: payload
      };

    case NEW_CAPTURE:
      return {
        ...state,
        isAddMode: true,
        isDeleteMode: false
      };

    case SET_NEW_CAPTURE: {
      const newCaptures = [payload, ...state.captures];

      return {
        ...state,
        captures: newCaptures
      };
    }

    case SET_EDITED_CAPTURE: {
      const newCaptures = [...state.captures];
      const indexToEdit = newCaptures.findIndex(
        capture => capture.id === payload.id
      );

      if (indexToEdit !== -1) {
        newCaptures[indexToEdit] = payload;
      }

      return {
        ...state,
        captures: newCaptures
      };
    }

    case DELETE_CAPTURE:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: true
      };

    case CLEAR_CAPTURES:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
};
